<div class="container">
  <img [ngClass]="imageClass" [attr.src]="imgSrc" [attr.alt]="" [class]='htmlClass' #memberImage>
</div>